import React, { useEffect, useState } from 'react';
import AdSense from 'react-adsense';

import { connect } from 'react-redux';

import { Link, useHistory } from 'react-router-dom';

import TreeComparator from '../logic/TreeComparator';
import {
  rollbackRumbleState,
  setupRumbleState,
  updateRumbleStateWithWinner,
} from '../redux/actions';
import {
  getComparator,
  getCurrentListInfo,
  getLeftComparison,
  getRankingTimes,
  getRightComparison,
  getUser,
  hasPreviousState,
  isRumbleComplete,
  isUserReady,
} from '../redux/selectors';
import ShowdownItem from '../components/Showdown/ShowdownItem';
import { ANIMATIONTIMER, LEFT, RIGHT } from '../Constants';
import WhiteLabelOverride from '../components/Showdown/WhiteLabelOverride';
import Button from '../components/Button/Button';
import PageHeader from '../components/PageHeader/PageHeader';
import clsx from 'clsx';

function RumbleShowdownPage(props) {
  const [ready, setReady] = useState(false);
  const [animating, setAnimating] = useState(false);
  const search = location.search;
  const participantId = new URLSearchParams(search).get('user');

  let setupRumbleState = props.setupRumbleState;

  let history = useHistory();

  useEffect(() => {
    if (props.currentList === null) {
      history.push('/');
      return;
    }

    if (props.isRumbleComplete) {
      let redirect = '/List';
      if (participantId) {
        redirect += `?user=${participantId}`;
      }
      history.push(redirect);
    }

    if (ready) {
      return;
    }

    setReady(true);
    setupRumbleState(TreeComparator, props.currentList.items);
  }, [
    props.currentList,
    props.comparator,
    props.isRumbleComplete,
    history,
    participantId,
    ready,
    setupRumbleState,
    props.rankingTimes,
  ]);

  if (!ready) {
    return <div>Setting up rumble</div>;
  }

  if (props.isRumbleComplete) {
    return null;
  }

  return (
    <>
      <WhiteLabelOverride whiteLabelInfo={props.currentList.whiteLabelInfo} />

      {props.user && props.ready && (
        <PageHeader
          props={props}
          title={'Showdown'}
          logOutModal={props.logOutModal}
          editModal={props.editModal}
          isEditOpen={props.isEditOpen}
          isFullOpen={props.isFullOpen}
        />
      )}
      <div
        className={clsx(
          props.user && props.ready ? 'tablet:pt-32' : null,
          !props.user && props.ready ? 'pt-10' : null
        )}
      >
        <div className={'container'}>
          {!props.user && props.ready && (
            <div className={'text-center'}>
              <header className={'mb-8'}>
                <Link to='/' className={'inline'}>
                  <img
                    src={
                      props.currentList?.whiteLabelInfo?.imageURL ||
                      'img/rr-logo.png'
                    }
                    alt={
                      props.currentList?.whiteLabelInfo?.imageURL
                        ? `${props.currentList.authorCompany} logo`
                        : 'RumbleRank Logo'
                    }
                    className={'inline'}
                    width={'124'}
                    height={'96'}
                  />
                </Link>
              </header>
            </div>
          )}
          <div className={'flex flex-col gap-6 relative'}>
            <div className={'grid tablet:grid-cols-2 gap-7 w-full'}>
              <div
                className='ShowdownCorner RedCorner'
                onClick={() => {
                  if (!animating) {
                    setAnimating(true);
                    setTimeout(function () {
                      props.updateRumbleStateWithWinner(LEFT);
                      setAnimating(false);
                    }, ANIMATIONTIMER);
                  }
                }}
              >
                <ShowdownItem
                  name={props.leftComparison.name}
                  description={props.leftComparison.description}
                  imageURL={props.leftComparison.imageURL}
                  animating={animating}
                />
              </div>
              <div
                className='ShowdownCorner BlueCorner'
                onClick={() => {
                  if (!animating) {
                    setAnimating(true);
                    setTimeout(function () {
                      props.updateRumbleStateWithWinner(RIGHT);
                      setAnimating(false);
                    }, ANIMATIONTIMER);
                  }
                }}
              >
                <ShowdownItem
                  id={props.rightComparison.id}
                  name={props.rightComparison.name}
                  description={props.rightComparison.description}
                  imageURL={props.rightComparison.imageURL}
                  animating={animating}
                />
              </div>
            </div>
            {props.hasPreviousState ? (
              <div className={'w-full'}>
                <Button
                  variant={'secondary'}
                  onClick={props.rollbackRumbleState}
                >
                  Previous Question
                </Button>
              </div>
            ) : null}
            {props.currentList.showAds && (
              <div className={'text-center'}>
                <AdSense.Google
                  client='ca-pub-2400035618862060'
                  slot='4877866478'
                  style={{ display: 'block' }}
                  layout='in-article'
                  format='fluid'
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    ready: isUserReady(state),
    comparator: getComparator(state),
    isRumbleComplete: isRumbleComplete(state),
    hasPreviousState: hasPreviousState(state),
    leftComparison: getLeftComparison(state),
    rightComparison: getRightComparison(state),
    currentList: getCurrentListInfo(state),
    rankingTimes: getRankingTimes(state),
  };
}

export default connect(mapStateToProps, {
  setupRumbleState,
  updateRumbleStateWithWinner,
  rollbackRumbleState,
})(RumbleShowdownPage);
